module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/5d7709a8da0dad0c75f8a47c5938c3f3.jpg";